import { gql } from '@apollo/client'

export const SEARCH_POSTAL_CODES_QUERY = gql`
  query searchPostalCodes($query: String!, $country: String, $limit: Int) {
    searchPostalCodes(query: $query, country: $country, limit: $limit) {
      query
      country
      count
      results {
        zipcode
        place
        state
        stateCode
        countryCode
      }
    }
  }
`
